var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 25,
    rx: 3,
    fill: "#A1FFC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.83 11.8861C21.6834 11.6866 18.1779 7 12.5 7C6.82217 7 3.31667 11.6866 3.17005 11.8861C2.94332 12.1951 2.94332 12.6049 3.17005 12.9139C3.31667 13.1134 6.82217 17.8 12.5 17.8C18.1779 17.8 21.6834 13.1134 21.83 12.9139C22.0567 12.6049 22.0567 12.1951 21.83 11.8861ZM12.5 16.9C7.25349 16.9 3.95002 12.4 3.95002 12.4C3.95002 12.4 7.25349 7.9 12.5 7.9C17.7465 7.9 21.05 12.4 21.05 12.4C21.05 12.4 17.7465 16.9 12.5 16.9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.80005C10.4014 8.80005 8.69995 10.4116 8.69995 12.4C8.69995 14.3885 10.4011 16 12.5 16C14.5988 16 16.3 14.3885 16.3 12.4C16.3 10.4116 14.5985 8.80005 12.5 8.80005ZM12.5 15.1C10.9283 15.1 9.64995 13.889 9.64995 12.4C9.64995 10.9111 10.9283 9.70005 12.5 9.70005C14.0716 9.70005 15.35 10.9111 15.35 12.4C15.35 13.889 14.0716 15.1 12.5 15.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.015d16a1857b35d3852e2ef8f2a1662e.svg";
export { ForwardRef as ReactComponent };